import { APIRouteFunc } from '@/modules/utils'
import { HydraCollection } from 'emt-library'
import { DogBreed } from '@/dataV3/Animal/DogBreed'
import { AnimalSpecies } from '@/dataV3/Animal/AnimalSpecies'

export type Response = HydraCollection<DogBreed>

export const Route: APIRouteFunc = (species: AnimalSpecies) => ({
  method: 'GET',
  path: `/v2/dog_breeds?species=${species}`,
})
